import { useParams } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { RubricsWorkspace } from '../components/evaluation/RubricsWorkspace';

/**
 * ADMIN-02 — one rubric, open beside the list (admin redesign batch 2, Option A). `new` starts a blank one; an older version's
 * id opens that version read-only. Saving an existing rubric writes its next version: jobs already using this one keep it, and
 * every line keeps its key so interview kits still find it (master plan S12, QA test 4).
 */
export function RubricEditorPage(): ReactNode {
  const { rubricId } = useParams({ from: '/app-layout/admin/rubrics/$rubricId' });
  return <RubricsWorkspace selectedId={rubricId} />;
}
